module.exports = __webpack_public_path__ + "static/media/17_hum_a.4de79e27.ogg";